import React from "react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StrategicArchitecture() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: imgVisible
  } = useRevealOnScroll();
  return <section id="strategic-architecture" className="relative flex min-h-[90vh] w-full flex-col lg:flex-row bg-background overflow-hidden">
      {}
      <div className="flex w-full flex-col justify-center px-8 py-20 lg:w-1/2 lg:px-24 lg:py-0">
        <div ref={textRef} className={cn("transition-all duration-1000 ease-out transform", textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h1 className="font-serif text-5xl font-bold leading-[1.1] tracking-tight text-foreground sm:text-6xl md:text-7xl lg:text-[5.5rem]">Strategic<br />Framework</h1>
          <p className="mt-6 max-w-md font-sans text-lg text-muted-foreground/80 md:text-xl">Strategic guidance for globally mobile entrepreneurs.</p>
        </div>
      </div>

      {}
      <div className="relative h-[50vh] w-full lg:h-auto lg:w-1/2">
        <div ref={imgRef} className={cn("absolute inset-0 h-full w-full transition-opacity duration-1000 ease-in-out delay-300", imgVisible ? "opacity-100" : "opacity-0")}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1552867/img/inspiring_city_skyline_promenade_palm_trees.png" alt="Inspiring photo‑realistic city skyline with a seaside promenade lined with palm trees, conveying low‑key tax haven vibes for successful global entrepreneurs." className="h-full w-full object-cover" />
          {}
          <div className="absolute inset-0 bg-black/5 lg:bg-transparent" />
        </div>
      </div>
    </section>;
}